import React from 'react';

import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import classNames from 'classnames';

import classes from './VideoPreview.module.scss';
import { openModal } from '../../../shared/utils/reactUtils/openModal/openModal';
import { YoutubeVideoModal } from '../YoutubeVideoModal/YoutubeVideoModal';

type VideoPreviewProps = {
  imgSrc: string;
  videoLink: string;
  className?: string;
};
/**
 * @description Video preview component with hover effect and play icon show video in modal on click
 * Use hight or width to set aspect ratio (16:9)
 */
const VideoPreview = ({ imgSrc, videoLink, className }: VideoPreviewProps) => {
  const handleVideoClick = () => {
    openModal((closeModal) => (
      <YoutubeVideoModal open onClose={closeModal} videoSrc={videoLink} />
    ));
  };

  return (
    <div className={classNames(classes.imgBox, className)} onClick={handleVideoClick}>
      <img src={imgSrc} alt="video" />
      <div className={classes.hoverBg}>
        <div className={classes.playIconBox}>
          <PlayArrowRoundedIcon color="white" fontSize="extraLarge" />
        </div>
      </div>
    </div>
  );
};

export { VideoPreview };
